import React, { useState } from "react";
import { useStateContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";

const LanguageNavigate = ({
    support = ["en", "ar"],
    redirect
}) => {
    const {
        langCode,
        changeLanguage,
        langs,
        isLangRTL,
        i18n
    } = useStateContext();

    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    // Filter languages based on support prop, if provided
    const supportedLangs = support
        ? langs.filter((lang) => support.includes(lang.code))
        : langs;

    // CURRENT LANG
    // const currentLang = langs.find((lang) => lang.code === langCode);
    const currentLang = supportedLangs.find((lang) => lang.code === langCode);

    // TOGGLE DROPDOWN 
    const toggleDropdown = () => setIsOpen(!isOpen);

    // HANDLE LANGUAGE CHANGE 
    const handleLanguageChange = (code) => {
        changeLanguage(code);
        setIsOpen(false);

        if (redirect) {
            const currentParams = window.location.search;
            // const redirectUrl = `${redirect}${currentParams}`;

            let redirectUrl;
            // Check if redirect is a string or an object
            if (typeof redirect === "string") {
                redirectUrl = `${redirect}${currentParams}`;
            } else if (typeof redirect === "object" && redirect[code]) {
                redirectUrl = `${redirect[code]}${currentParams}`;
            } else {
                // Fallback: stay on current page or handle as needed
                redirectUrl = `${window.location.pathname}${currentParams}`;
            }
            navigate(redirectUrl);
        }
    };

    return (
        <div
            className={`${isLangRTL(i18n.language) ? "left-[7%]" : "right-[7%]"
                } fixed top-3 px-2 text-white text-sm cursor-pointer ${isOpen && "primary-bg rounded-sm"
                }`}
            style={{
                zIndex: 10,
            }}
            onClick={toggleDropdown}
        >
            <div className="flex items-center gap-1 my-2">
                <div className={`${isOpen ? "secondary-text" : "text-white"} uppercase text-white ${currentLang?.code == "fa" && "mt-2"}`}>
                    {currentLang?.code}
                </div>
                <img
                    src={currentLang?.flag}
                    alt={`${currentLang?.title} flag`}
                    className="inline-block w-4 h-3 border"
                    width="10"
                />
            </div>
            {/* DROPDOWN */}
            {isOpen && (
                <>
                    <div className={`transition-all duration-500 ease-in-out`} >
                        {supportedLangs
                            .filter((lang) => lang.code !== langCode)
                            .map((lang) => (
                                <div
                                    key={lang.code}
                                    className="flex items-center gap-1 my-2"
                                    onClick={() => handleLanguageChange(lang.code)}
                                >
                                    <div className="uppercase text-white">
                                        {lang?.code}
                                    </div>
                                    <img
                                        src={lang.flag}
                                        alt={`${lang.title} flag`}
                                        className="inline-block w-4 h-3 border"
                                    />
                                </div>
                            ))}
                    </div>
                </>
            )}

        </div>
    );
};

export default LanguageNavigate;
